export default "__VITE_ASSET__C5k6UYdV__"